<div [class]="classes()">
  @if (icon) {
    <mat-icon>{{ icon() }}</mat-icon>
  }
  <span class="body1">{{ text() }}</span>
</div>
